module.exports = __webpack_public_path__ + "static/satelliteMap-dfa0d5211711bd345d53c4817be1ac28.jpg";